import { getMessages } from '../../../../../../store/constants';

export const BUTTON_TEXT_UPGRADE_MY_PLAN = getMessages().getText('dialog.blocker.button-upgrade-my-plan');
